import "./css/App.css";
import "./css/reactSearchStyle.css";

import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { I18nextProvider, useTranslation } from "react-i18next";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DotLoader } from "react-spinners";
import { toast, ToastContainer } from "react-toastify";

import AuthenticateWrapper from "./components/authenticateWrapper";
import Header from "./components/header";
import Login from "./components/Login";
import { isProdStage } from "./constants/AppConstant";
import AppContext from "./context/app-context";
import i18n from "./i18n";
import AboutPage from "./page/AboutPage";
import AboutUsPage from "./page/AboutUsPage";
import ExpenseDetailPage from "./page/ExpenseDetailPage";
import { ExpenseTrackingPage } from "./page/ExpenseTrackingPage";
import HomePage from "./page/homePage";
import MetricsGraphPage from "./page/MetricsGraphPage";
import ProfilePage from "./page/ProfilePage";
import ReceiptUploadPage from "./page/ReceiptUploadPage";
import userProfileService from "./services/userProfileService";
import FAQPage from "./StaticPage/FAQPage";
import PrivacyPolicy from "./StaticPage/PrivacyPolicy";
import TermsOfService from "./StaticPage/TermsOfService";
import ExpenseTrackingMetadataDB from "./storage/ExpenseTrackingMetadataDB";
import { delay } from "./utils/helperFunctions";
import BulkAddExpensePage from "./page/BulkAddExpensePage";
import CreditCardPage from "./page/CreditCardPage";

// import "react-select-search/style.css";
export const APP_ROUTE_LIST = [
  {
    path: "/",
    element: <HomePage />, // <AuthenticateWrapper components={<TicTacToe />} />,
  },
  {
    path: "/about",
    element: <AboutPage />, // <AuthenticateWrapper components={<TicTacToe />} />,
  },
  {
    path: "/terms",
    element: <TermsOfService />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/cards",
    element: <CreditCardPage />,
  },
  {
    path: "/login",
    element: <AuthenticateWrapper components={<Login />} />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/bulk",
    element: <BulkAddExpensePage />,
  },
  {
    path: "/details/:id",
    element: <ExpenseDetailPage />,
  },
  {
    path: "/upload",
    element: <ReceiptUploadPage />,
  },
  {
    path: "/ExpenseTracking",
    element: <ExpenseTrackingPage />,
  },
  {
    path: "/oauth2/idpresponse",
    element: <HomePage />,
  },
  {
    path: "/logout",
    element: <HomePage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/aboutus",
    element: <AboutUsPage />,
  },
  {
    path: "/graphs",
    element: <MetricsGraphPage />,
  },
];
function App() {
  const [loading, setLoading] = useState(false);
  const [appRefresh, setAppRefresh] = useState(0);
  const [userProfile, setUserProfile] = useState(null);
  const [trackingItems, setTrackingItems] = useState([]);
  const [onlineItems, setOnlineItems] = useState([]);

  const { t } = useTranslation();
  useEffect(() => {
    userProfileService.getUserProfile({
      callback: ({ userProfile: profile, error }) => {
        if (error) {
          toast.error(error);
          return;
        }
        setUserProfile(profile);
        if (!profile) {
          setTrackingItems([]);
          setOnlineItems([]);
        }
      },
    });
  }, [appRefresh]);

  async function loadItems() {
    // setLoading(true);
    const items = await ExpenseTrackingMetadataDB.getAllTrackingSpends();
    setTrackingItems(items);
    // setLoading(false);
    return items;
  }
  async function loadItemsFromOnline() {
    if (!userProfile) return;
    // setLoading(true);
    const { userId } = userProfile;
    const allOfflineItems = await loadItems();
    const offlineItems = allOfflineItems.filter((item) => item.userId === userId);
    const lastUpdatedItem = offlineItems.sort((a, b) => new Date(b.lastModifiedDate) - new Date(a.lastModifiedDate))[0];
    var LastEvaluatedKey = null;
    let expenseItems = [];
    var lastModifiedDate = undefined;
    if (lastUpdatedItem) {
      lastModifiedDate = lastUpdatedItem.lastModifiedDate;
    }
    while (LastEvaluatedKey !== undefined) {
      const { data = {}, errorMsg } = await userProfileService.getExpenseEvent({
        userId,
        lastModifiedDate,
        LastEvaluatedKey: LastEvaluatedKey === null ? undefined : LastEvaluatedKey,
      });
      if (errorMsg) {
        return;
      }
      expenseItems = [...expenseItems, ...data.items];
      LastEvaluatedKey = data.LastEvaluatedKey;
      for (const onlineItem of expenseItems) {
        if (
          !offlineItems.find((item) => item.id === onlineItem.id && item.lastModifiedDate === onlineItem.lastModifiedDate)
        ) {
          await ExpenseTrackingMetadataDB.putItemToExpenseTrackingMetadata(onlineItem);
        }
      }

      setOnlineItems(expenseItems);
      loadItems();
      await delay(1.5);
    }
    // setLoading(false);
  }
  useEffect(() => {
    loadItems();
    if (userProfile) {
      loadItemsFromOnline();
    }
  }, [userProfile]);
  return (
    <I18nextProvider i18n={i18n}>
      <div className="App">
        <BrowserRouter>
          <AppContext.Provider
            value={{
              loading,
              setLoading,
              userProfile,
              setAppRefresh,
              loadItems,
              trackingItems,
              onlineItems,
              loadItemsFromOnline,
              i18n,
            }}
          >
            <>
              {loading && (
                <div className="fadeMe">
                  <DotLoader color="#36d7b7" loading={loading} className={"spinner"} />
                </div>
              )}
              <Header />
              {!isProdStage && (
                <Alert variant="danger" className="mt-4">
                  This is a testing stage,
                  <a href="https://kokofin.com/" alt="prod url">
                    please use https://kokofin.com/
                  </a>
                </Alert>
              )}
              <div className="container">
                <Routes>
                  {APP_ROUTE_LIST.map((item) => {
                    return <Route key={item.path} path={item.path} element={item.element} />;
                  })}
                </Routes>
              </div>
            </>
          </AppContext.Provider>
        </BrowserRouter>
        <ToastContainer />
      </div>
    </I18nextProvider>
  );
}

export default App;
